import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import HeaderBread from "../../../components/HeaderBread";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import SeoMetaTagInput from "../../../components/SeoMetaTagInput/SeoMetaTagInput";
import { getSeoMetaTagById } from "../../../utils/ApiCalls/SeoMetaTag";

const EditSeoMetaTag = () => {
  const params = useParams();
  const [seoMetaTag, setSeoMetaTag] = useState({});
  const [, dispatch] = useDataLayerValue();

  const navigation = [
    { title: "Home", route: "/" },
    { title: "SEO Meta Tag List", route: "/website/webpages/seo-meta-tag" },
    { title: "Edit SEO Meta Tag", route: "/website/webpages/seo-meta-tag/edit" },
  ];

  useEffect(() => {
    getData(params?.id);
  }, [params]);

  const getData = async (id) => {
    dispatch({ type: "SET_LOADING", loading: true });
    const data = await getSeoMetaTagById(id);
    if (data?.error) {
      dispatch({ type: "SET_ERROR_MESSAGE", errMess: { message: data.error, type: "error" } });
    } else if (data?.id) {
      setSeoMetaTag(data);
    }
    dispatch({ type: "SET_LOADING", loading: false });
  };

  return (
    <Layout type={"update_per"} module_data={"SEO Meta Tag"}>
      <CustomHeaderTitle title={"Edit SEO Meta Tag"} />
      <HeaderBread navigation={navigation} title={"Edit SEO Meta Tag"} />
      {seoMetaTag?.id && <SeoMetaTagInput seoMetaTag={seoMetaTag} />}
    </Layout>
  );
};

export default EditSeoMetaTag;
